import React, { useEffect, useState } from "react";
import axios from "axios";
import SeatMap from "../components/SeatMap";
import { useNavigate } from "react-router-dom";

const API = process.env.REACT_APP_API_URL;

const LibrarySeatMap = () => {
  const [seatData, setSeatData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const fetchLibrarySeats = async () => {
    try {
      const res = await axios.get(`${API}library/seats/live-map/`);
      setSeatData(res.data);
      setError("");
    } catch (err) {
      console.error("Error loading library seat data", err);
      setError("⚠️ Could not load library seat data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLibrarySeats();
  }, []); // initial load

  useEffect(() => {
    const buildWsUrl = () => {
      if (API) {
        const base = API.replace(/\/$/, "");
        return base.replace(/^http/, "ws") + "/ws/live-seat-updates/";
      }
      if (process.env.NODE_ENV === "development") {
        return "ws://localhost:8000/ws/live-seat-updates/";
      }
      return "wss://api.profsspatilstudycenter.com/ws/live-seat-updates/";
    };

    const socket = new WebSocket(buildWsUrl());

    socket.onopen = () => {
      console.log("[WS] LibrarySeatMap connected");
    };

    socket.onmessage = (event) => {
      try {
        const payload = JSON.parse(event.data);
        const data = payload?.data || payload;

        if (
          data?.type === "library_booking_approved" ||
          data?.type === "library_booking_rejected" ||
          data?.type === "library_booking_cancelled" ||
          data?.type === "library_available_switch" ||
          data?.type === "library_mutual_switch"
        ) {
          console.log("[WS] LibrarySeatMap refresh on event:", data.type);
          fetchLibrarySeats();
        }
      } catch (e) {
        console.error("WS message parse error:", e);
      }
    };

    socket.onerror = (err) => {
      console.error("[WS] LibrarySeatMap error:", err);
    };

    socket.onclose = () => {
      console.log("[WS] LibrarySeatMap closed");
    };

    return () => {
      socket.close();
    };
  }, []);

  const handleSeatClick = (seat) => {
    navigate(`/library/book/${seat.id}`);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>📚 Library Live Seats</h2>
      {loading ? (
        <p>Loading seats...</p>
      ) : error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : (
        <SeatMap
          data={seatData}
          onSeatClick={handleSeatClick}
          refreshData={fetchLibrarySeats}
        />
      )}
    </div>
  );
};

export default LibrarySeatMap;